export default "__VITE_ASSET__DgmB8aLm__"